import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  SidesheetType,
  selectCurrentSidesheet,
  selectFocusedSessionAppointment,
} from "store/calendarSidebarSlice";
import styles from "./SessionSidesheet.module.scss";
import EditSession from "./edit-session/EditSession";
import SessionDetails from "./session-details/SessionDetails";

const SessionSidesheet = () => {
  const appointment = useSelector(selectFocusedSessionAppointment);
  const currentSidesheet = useSelector(selectCurrentSidesheet);

  const isEditing = useMemo(
    () => currentSidesheet === SidesheetType.EditSession,
    [currentSidesheet],
  );

  if (!appointment) {
    return null;
  }

  return (
    <div className={styles["session-info"]}>
      {isEditing ? (
        <EditSession appointment={appointment} />
      ) : (
        <SessionDetails appointment={appointment} />
      )}
    </div>
  );
};

export default SessionSidesheet;
